<template>
  <div class="usercenter">
    <div class="userhead">
      <div class="useroperation">
        <van-icon class="iconfont m-r-20" size="30" color="#c4e7f1" class-prefix="icon" name="vip"
                  @click="$router.push('/user/product')"/>
        <!-- <van-icon class="iconfont" size="30" color="#c4e7f1" class-prefix="icon" name="shezhi" /> -->
      </div>
      <van-row type="flex" justify="space-around" align="center" class="p-t-50">
        <van-col span="6">
          <van-image style="border:5px solid #9cd2d1;width:100%" fit="scale-down"
                     :src="user.headImg||'https://img.yzcdn.cn/vant/cat.jpeg'"/>
        </van-col>
        <van-col span="8" class="name">
          <div class="f-20">{{ user.nickname ? user.nickname : user.uname }}</div>
          <div>{{ user.tel }}</div>
        </van-col>
        <van-col span="8" class="name">
          <div>
            <!-- 积分：100 -->
          </div>
          <!-- <div>积分：{{user.score}}</div> -->
        </van-col>
      </van-row>
    </div>
    <ul class="functionlist">
      <li>
        <van-cell title-style="text-align:left;" is-link @click="userInfoLayerShow=true">
          <template #title>
            <van-icon class="m-r-5" size="20" color="#e6c47c" name="setting-o"/>
            <span class="custom-title">我的资料</span>
          </template>
        </van-cell>
        <van-cell v-if="false" title-style="text-align:left;" is-link @click="newsListLayer.isShow=true">
          <template #title>
            <van-icon class="iconfont m-r-5" size="20" color="#e88c8c" class-prefix="icon" name="xinxi"/>
            <span class="custom-title">我的消息</span>
            <!-- <van-tag round type="danger" class="m-l-5">5</van-tag> -->
          </template>
        </van-cell>
        <van-cell v-if="false" title-style="text-align:left;" is-link to="score">
          <template #title>
            <van-icon class="iconfont m-r-5" size="20" color="#e6c47c" class-prefix="icon" name="jifen"/>
            <span class="custom-title">我的积分</span>
          </template>
        </van-cell>
        <van-cell title-style="text-align:left;" :value="global.formatDate(user.endDate,'yyyy-MM-dd')">
          <template #title>
            <van-icon class="iconfont m-r-5" size="20" color="#829ab8" class-prefix="icon" name="shouxufeix"/>
            <span class="custom-title">VIP期限</span>
          </template>
        </van-cell>
      </li>
      <li>
        <van-cell v-if="user.isCreator<=1" title-style="text-align:left;" is-link
                  @click="user.isCreator==1?$router.push({path:'case'}):bangshou.tips.show=true">
          <template #title>
            <van-icon class="iconfont m-r-5" size="30" color="#44708e" class-prefix="icon" name="weixiurenyuan"/>
            <div style="display:inline;" class="bangshoucell">
              {{ user.isCreator == 1 ? "我是帮手" : "申请为帮手" }}
              <!-- <span>可以发布案例</span> -->
            </div>
          </template>
        </van-cell>
        <van-cell v-if="false&&user.isCreator<=1" title-style="text-align:left;" is-link
                  @click="showVideo('/video/video-3.mp4')">
          <template #title>
            <van-icon name="play-circle-o" size="22" color="#4f98c2"/>
            <span class="custom-title"> 案例上传说明</span>
          </template>
        </van-cell>
        <van-cell v-if="false" title-style="text-align:left;" is-link to="/repair/caselist?type=viewlist">
          <template #title>
            <van-icon class="iconfont m-r-5" size="20" color="#75bc8d" class-prefix="icon" name="shu"/>
            <span class="custom-title">我查阅过的案例</span>
          </template>
        </van-cell>
      </li>
      <li>
        <!-- <a v-if="company.tel" :href="'tel:'+company.tel">
          <van-cell title-style="text-align:left;" is-link>
            <template #title>
              <van-icon class="iconfont m-r-5" size="20" color="#8bf17f" class-prefix="icon" name="lianxiwomen" />
              <span class="custom-title">客服</span>
            </template>
          </van-cell>
        </a> -->
        <van-cell title-style="text-align:left;" is-link @click="logout">
          <template #title>
            <van-icon class="iconfont m-r-5" size="20" color="#999999" class-prefix="icon" name="tuichu"/>
            <span class="custom-title">退出</span>
          </template>
        </van-cell>
      </li>
    </ul>
    <MainMenuNav/>
    <van-popup v-model="bangshou.video.isShow" @closed="bangshou.video.isShow=false" closeable position="bottom"
               style="padding-top:50px; background:none;" :style="{ height: '90%' }">
      <VideoModule :video="bangshou.video"></VideoModule>
    </van-popup>
    <van-popup v-model="bangshou.tips.show" round :style="{ width:'90%' }">
      <div class="p-10" style="color:#535353; line-height:180%">
        <div class="m-t-10 m-b-10" style="color:red;">申请为帮手</div>
        <div class="line-1"></div>
        <div>
          <p style="color:#535353; line-height:180%"> 请联系客服</p>
          <div class="m-l-10 m-r-10 m-t-30 m-b-30">
            <van-button type="primary" @click="bangshou.tips.show = false;" color="#45a4b6" round block>关 闭</van-button>
          </div>
        </div>
        <!-- <div v-if="global.isNull(user.realName)">
          <p style="color:#535353; line-height:180%"> 申请为帮手必须在<br>“我的资料”里填写名称</p>
          <a @click="inputRealName" style="text-decoration:underline;color:blue;">
            <p>去填写名称</p>
          </a>
          <div class="m-l-10 m-r-10 m-t-30 m-b-30">
            <van-button type="primary" @click="bangshou.tips.show = false;" color="#45a4b6" round block>关 闭</van-button>
          </div>
        </div>
        <div v-else>
          <a @click="bangshou.agreenment.show=true" style="text-decoration:underline;color:blue;">
            <p>阅读“帮手守则”</p>
          </a>
          <p>点击“确认”，即为同意守则！</p>
          <div class="m-l-10 m-r-10 m-t-30 m-b-30">
            <van-button type="primary" @click="toCreator" color="#45a4b6" round block>确 认</van-button>
          </div>
        </div> -->
      </div>
    </van-popup>
    <van-popup v-model="bangshou.agreenment.show" position="right" :style="{ height: '100%',width:'100%' }">
      <van-nav-bar fixed placeholder title="案例帮手守则" left-arrow @click-left="bangshou.agreenment.show=false">
      </van-nav-bar>
      <div class="agreenment p-10" style="color:#535353; line-height:180%; text-align:left">
        <article>
          <section>
            <p>
              欢迎使用案例帮手系统（以下简称查询系统），请务必仔细阅读并透彻理解本守则。您在使用查询系统前，确认对本守则全部条款、规则及内容均已知晓、理解并接受，并已同意将其作为确定双方权利义务的依据。如您使用查询系统账号上传案例或以其他方式使用或接受服务，即视为您已阅读并与查询系统达成协议，自愿接受本守则全部条款、规则及内容的约束。所有服务规则视为本条款不可分割的一部分，与本条款具有同等法律效力。
            </p>
          </section>
          <section>
            <dl>
              <dt>一、用户注册及服务使用</dt>
              <dd>
                1.“案例帮手账号”是指您通过查询系统网页端或移动智能设备应用端注册的账号。需要您在登录您的账号之后方可使用。您在注册时所填写的内容与个人资料必须真实、准确、有效，否则查询系统有权拒绝您的上传申请。在完成账号注册手续后，您将有权通过该账号使用本服务。
              </dd>
              <dd>2.
                您在使用查询系统服务时，所发布的信息（包括用户名称、用户头像、帮手案例等）及用户行为必须遵守国家有关法律规定以及服务规则，并承担一切因自己发布信息或其他行为导致的民事、行政、或刑事法律责任或其他不利后果，
                所发布的信息不得含有以下内容或用于以下目的：
                <ul>
                  <li>（1）违反宪法确定的基本原则的；</li>
                  <li>（2）危害国家安全，颠覆国家政权，破坏国家统一，损害国家荣誉和利益的；
                  </li>
                  <li>（3）煽动民族仇恨、民族歧视，破坏民族团结的；
                  </li>
                  <li>（4）违背中华民族传统美德、社会公德、伦理道德、以及社会主义精神文明的；
                  </li>
                  <li>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；
                  </li>
                  <li>（6）散布谣言或不实消息，扰乱社会秩序，破坏社会稳定的；
                  </li>
                  <li>（7）煽动、组织、教唆恐怖活动、非法集会、结社、游行、示威、聚众扰乱社会秩序的；
                  </li>
                  <li>（8）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
                  </li>
                  <li>（9）侮辱或诽谤他人，侵犯他人肖像权、姓名权、名誉权、隐私权或其他人身权利的；
                  </li>
                  <li>（11）以非法组织名义活动的；
                  </li>
                  <li>（12）侵犯他人知识产权、商业秘密等合法权益的；
                  </li>
                  <li>（13）含有违反法律、法规、国家政策及公序良俗的法律、行政法规禁止的其他内容的。</li>
                </ul>
              </dd>
              <dd>4. 如果您在使用查询系统服务时，未能遵守本协议或其他服务规则的规定，为了维护良好服务环境，保障其他用户的合法权益，查询系统有权删除您发布的相关信息，暂时或永久禁止您在查询系统发布信息，直至封停您的账号，
              </dd>
              <dd>5.
                依照监管要求，对于查询系统在向您提供服务时向您提供的或您在使用查询系统服务时获取的数据及服务信息等，您应当仅在中华人民共和国范围内储存或使用，同时您不得利用查询系统提供的数据及服务信息从事任何违反法律、法规或其他监管政策的行为。否则，由此产生的一切不利法律后果由您自行承担.
              </dd>
            </dl>
          </section>
          <section>
            <dl>
              <dt>二、帮手每月积分提成规定</dt>
              <p> 当您通过查询系统途径成为案例帮手（以下简称“帮手”）时以及本系统所换取积分后您使用积分换取提成的同时，须一并遵守本条的以下规定。</p>
              <dd>(一)积分累计情况
                <ul>
                  <li>1.积分累计是指帮手上传案例后，查询用户以积分方式读取内容时所扣除积分，相应的扣除的积分会累计为帮手的积分。</li>
                  <li>2.积分采取当月累积，次月自动清零的规则。当月是指自然月1号至每月最后一天。</li>
                  <li>3.帮手可以在查询系统里面查看所上传案例的当月阅览量及累计积分。</li>
                </ul>
              </dd>
              <dd>(二)积分换取提成方式
                <ul>
                  <li>1.查询系统工作人员会在每月15号之前结算上一个自然月帮手所有案例被阅览总量和积分，并计算应向帮手支付的提成。</li>
                  <li> 2.查询系统工作人员会按照帮手所留下账号（以支付宝账号为主）支付上述提成。帮手无法事先申请。</li>
                  <li> 3.按照国家税法规定，查询系统工作人员在支付前会先行代扣代缴个人综合所得税。</li>
                </ul>
              </dd>
            </dl>
          </section>
        </article>
      </div>
    </van-popup>
    <van-popup v-model="userInfoLayerShow" position="right"
               :style="{ height: '100%',width:'100%','background-color': '#ececec' }">
      <van-nav-bar fixed placeholder left-text="个人资料" left-arrow @click-left="userInfoLayerShow=false">
      </van-nav-bar>
      <ul class="functionlist">
        <li style="margin-top:0;">
          <van-cell title="头像" title-style="text-align:left;" @click="updateLayerShow=true">
            <template #default>
              <van-image width="40" height="40" :src="user.headImg||'https://img.yzcdn.cn/vant/cat.jpeg'"/>
            </template>
          </van-cell>
          <van-cell title-style="text-align:left;" :value="user.uname">
            <template #title>
              <span class="custom-title">用户名</span>
            </template>
          </van-cell>
          <van-cell title-style="text-align:left;" :value="user.nickname" is-link @click="layerShow('nickname')">
            <template #title>
              <span class="custom-title">姓名</span>
            </template>
          </van-cell>
        </li>
        <li style="margin-top:-15px;">
          <van-cell title-style="text-align:left;" is-link @click="layerShow('password')">
            <template #title>
              <span class="custom-title">密码变更</span>
            </template>
          </van-cell>
          <van-cell title-style="text-align:left;" is-link :value="user.tel" @click="layerShow('tel')">
            <template #title>
              <span class="custom-title">电话变更</span>
            </template>
          </van-cell>
          <van-cell v-if="isWxBind" title-style="text-align:left;">
            <template #title>
              <span class="custom-title">微信变更</span>
            </template>
            <template #default>
              <van-button size="small" @click="deleteBind" type="default">解绑</van-button>
            </template>
          </van-cell>
        </li>
      </ul>
    </van-popup>
    <van-popup class="updatelayer" v-model="updateLayer.isShow" position="right"
               :style="{ height: '100%',width:'100%' }">
      <van-form @submit="onSubmit">
        <van-nav-bar fixed placeholder :left-text="updateLayer.title" left-arrow @click-left="updateLayer.isShow=false">
          <template #right>
            <van-button size="mini" :disabled="updateLayer.buttonDisable" block type="primary" native-type="submit">
              保存
            </van-button>
          </template>
        </van-nav-bar>
        <van-cell-group :border="false" class="b-g-c-n formcontent">
          <div v-if="updateLayer.updateUserName" class="username">
            <van-field border v-model="user.nickname" name="nickname" ref="nickname"
                       @input="updateLayer.buttonDisable=false" placeholder="在此填写姓名"/>
            燕过留声，人过留名
          </div>
          <div v-if="updateLayer.updatePassword" class="password">
            <van-field v-if="false" class="b-g-c-n cell iconfont" icon-prefix="icon" left-icon="mimayanzhengma"
                       type="password" v-model="formData.password" name="oldPassword"
                       :rules="[{ validator: passwordValidator, message: '当前密码不正确' }]" placeholder="当前密码"/>
            <van-field class="b-g-c-n cell iconfont" icon-prefix="icon" left-icon="mimayanzhengma" type="password"
                       v-model="formData.password1" name="password"
                       :rules="[{ pattern:formData.verifyPatterns.password, message: '6-15位数字和字母组成' }]"
                       placeholder="新密码"/>
            <van-field class="b-g-c-n cell iconfont" icon-prefix="icon" left-icon="mimayanzhengma" type="password"
                       v-model="formData.password2" name="password2" :rules="[{ required: true, message: '请再次输入密码' }]"
                       placeholder="确认密码" @input="updateLayer.buttonDisable=false"/>
            <van-field/>
          </div>
          <div v-if="updateLayer.updateTel" class="tel">
            <van-field name="tel" class="b-g-c-n cell iconfont" icon-prefix="icon" left-icon="shouji" type="tel"
                       v-model="formData.tel" placeholder="新的手机号码"
                       :rules="[{ pattern:formData.verifyPatterns.tel, message: '请正确输入(不需要地区码)' },{ validator: asyncValidator, message: '此号码已注册' }]"/>
            <van-field name="code" icon-prefix="icon" left-icon="yanzhengma" v-model="formData.code" type="number"
                       placeholder="验证码" maxlength=6 :rules="[{ required: true, message: '请输入验证码' }]"
                       class="b-g-c-n cell iconfont">
              <template #button>
                <van-button color="#52b1fc" v-show="!verifyData.isSending" size="small" type="info" @click="sendCode"
                            native-type="button">发送验证码
                </van-button>
                <van-button color="#52b1fc" v-show="verifyData.isSending" size="small" type="info" disabled>
                  <van-count-down ref="countDown" style="display: inline-block; color:#fff;" :time="verifyData.time"
                                  @finish="finish" format="ss秒后重发"/>
                </van-button>
              </template>
            </van-field>
            <van-field/>
          </div>
        </van-cell-group>
      </van-form>
    </van-popup>
    <van-popup class="newsListlayer" v-model="newsListLayer.isShow" position="right"
               :style="{ height: '100%',width:'100%' }">
      <van-nav-bar fixed placeholder left-text="我的消息" left-arrow @click-left="newsListLayer.isShow=false">
      </van-nav-bar>
      <div class="newslist">
        <van-list v-model="newsListLayer.news.loading" :finished="newsListLayer.news.finished" finished-text="没有更多了"
                  @load="loadNewsList">
          <van-cell title-style="text-align:left;" v-for="(item,index) in newsListLayer.news.list" :key="index"
                    :title="item.title"/>
        </van-list>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Col,
  Row,
  Image as VanImage,
  Icon,
  Cell,
  CellGroup,
  Tag,
  Popup,
  NavBar,
  Form,
  Button,
  Field,
  CountDown,
  Toast,
  List,
  Notify,
} from "vant";
import MainMenuNav from "@/components/MainMenuNav.vue";
import VideoModule from "@/components/Video.vue";
import {
  Check_Tel,
  Update_Nick_Name,
  Update_Tel,
  Update_Password,
  Check_Password,
  Get_News_List,
  Wx_Unbind,
  Get_Case_List,
  Send_SMS_Code,
  To_Creator,
} from "@/api/index";

export default {
  name: "UserIndex",
  components: {
    MainMenuNav,
    VideoModule,
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Button.name]: Button,
    [Field.name]: Field,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [List.name]: List,
    [Notify.name]: Notify,
  },
  data() {
    return {
      user: this.global.getUserInfo(),
      userInfoLayerShow: false,
      updateLayer: {
        isShow: false,
        buttonDisable: true,
        title: "",
        updateUserName: false,
        updatePassword: false,
        updateTel: false,
      },
      isWxBind: this.global.isWxBind(),
      newsListLayer: {
        isShow: false,
        news: {
          list: [],
          loading: false,
          finished: false,
          page: 1,
        },
      },
      bangshou: {
        video: {
          path: "",
          isShow: false,
        },
        tips: {
          show: false,
        },
        agreenment: {
          show: false,
        },
      },
      password: {},
      company: this.global.getMemberSystem(),
      formData: {
        tel: "",
        code: "",
        password: "",
        password1: "",
        password2: "",
        verifyPatterns: {
          tel: /(^1\d{10}$)|(^09[\d]{8}$)|(^[5|6|9]{1}\d{7}$)/,
          password: /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,15}$/,
        },
      },
      verifyData: {
        time: 60 * 1000,
        isSending: false,
      },
    };
  },
  methods: {
    //申请成为帮手
    toCreator() {
      To_Creator().then((user) => {
        Toast("申请成功！");
        this.global.loadUser(user);
        this.bangshou.tips.show = false;
        this.user = this.global.getUserInfo();
      });
    },
    //填写姓名
    inputRealName() {
      // this.bangshou.tips.show = false;
      this.updateLayer.isShow = true;
      this.updateLayer.updateUserName = true;
      // this.$refs.realName.focus();
    },
    //播放帮手说明视频
    showVideo: function (url) {
      this.bangshou.video.path = url;
      this.bangshou.video.isShow = true;
    },
    deleteBind() {
      Wx_Unbind().then((data) => {
        data.memberSystemId = data.systemId
        this.user = data;
        this.isWxBind = false;
        localStorage.setItem("User", JSON.stringify(data));
        localStorage.setItem("AccessToken", data.accessToken);
        localStorage.setItem("RefreshToken", data.refreshToken);
        sessionStorage.setItem("BindFlag", "true");
        Toast("解绑成功");
      });
    },
    async onSubmit(values) {
      if (this.updateLayer.updateUserName) {
        await Update_Nick_Name({nickname: values.nickname}).then((data) => {
          Toast("修改成功");
        });
      } else if (this.updateLayer.updateTel) {
        await Update_Tel({tel: values.tel, code: values.code}).then(
            (data) => {
              //同步修改前端用户电话
              this.user.tel = values.tel
              Toast("修改成功");
            }
        );
      } else if (this.updateLayer.updatePassword) {
        // if (values.oldPassword == "") {
        //   Toast("请输入密码");
        //   return;
        // }
        if (values.password == "") {
          Toast("请输入确认密码");
          return;
        }
        if (values.password != values.password2) {
          Toast("两次输入的密码不一致");
          return;
        }
        await Update_Password({
          oldPassword: "", // values.oldPassword,
          password: values.password,
          password2: values.password2,
        }).then((data) => {
          Toast("修改成功");
        });
      }
      this.user.memberSystemId = this.user.systemId
      localStorage.setItem("User", JSON.stringify(this.user));
      this.updateLayer.buttonDisable = true;
      this.updateLayer.isShow = false;
      // console.log("submit", values);
    },
    async asyncValidator() {
      return await Check_Tel({tel: this.formData.tel}).then(res => {
        this.updateLayer.buttonDisable = false
      });
    },
    passwordValidator(val) {
      if (val == "") {
        return false;
      }
      return Check_Password({password: this.formData.password});
    },
    finish() {
      this.verifyData.isSending = false;
    },
    async sendCode() {
      if (this.formData.tel == "") {
        Toast("请输入电话");
        return false;
      }
      this.verifyData.isSending = true;
      // this.verifyData.time = 60 * 1000;
      this.$refs.countDown.reset();
      let result = await Send_SMS_Code({tel: this.formData.tel, type: 0});
      if (!result) {
        this.verifyData.isSending = true;
      }
    },
    async logout() {
      localStorage.clear();
      // sessionStorage.clear();
      let memberSystem = await this.global.getMemberSystem();
      this.$router.push({path: "/?memberSystemId=" + memberSystem.memberSystemId});
    },
    layerShow(obj) {
      this.updateLayer.updateUserName = false;
      this.updateLayer.updatePassword = false;
      this.updateLayer.updateTel = false;
      switch (obj) {
        case "nickname":
          this.updateLayer.updateUserName = true;
          break;
        case "password":
          this.updateLayer.updatePassword = true;
          break;
        case "tel":
          this.updateLayer.updateTel = true;
          break;
      }
      this.updateLayer.isShow = true;
    },
    loadNewsList() {
      this.newsListLayer.news.loading = true;
      // Get_News_List({ pageSize: 20, page: this.newsListLayer.news.page }).then(
      //   (data) => {
      //     this.newsListLayer.news.finished =
      //       data.pageCount <= this.newsListLayer.news.page;
      //     this.newsListLayer.news.list = this.newsListLayer.news.list.concat(
      //       data.dataList
      //     );
      //     this.newsListLayer.news.page++;
      //     this.newsListLayer.news.loading = false;
      //   }
      // );
    },
  },
  async mounted() {
    await this.global.refreshToken(this.user.refreshToken);
    this.user = this.global.getUserInfo();
  },
};
</script>
